import * as React from 'react';
import { Heading2 } from "../../../../elements";
import { FormattedMessage } from '../ReadReportGuideModal';
export const EndPage = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading2, null,
            React.createElement(FormattedMessage, { id: 'readreport.guidemodal.end_page.title' })),
        React.createElement("section", { className: "ImageWithParagraph" },
            React.createElement("div", { className: "LastImage" }),
            React.createElement("article", null,
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.end_page.paragraph1' })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.end_page.paragraph2' })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.end_page.paragraph3' }))))));
};
